import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Select } from "antd";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import IQueryTradesBasicInfo from "src/services/interfaces/IQueryTradesBasicInfo";
import { SearchWorkflowCategoryEnum, SearchWorkflowCategoryLabel } from "src/services/interfaces/SearchWorkflowCategoryEnum";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import { ServiceContext } from "src/services/provider/Service.provider";
import ITradeBasicInfo from "../Refatoracao/ITradeBasicInfo";
import { SearchFilterEnum } from "../Refatoracao/TradeList/SearchFilterEnum";
import "./FindTrade.scss";
import { ButtonExport } from '../Refatoracao/Export/ExportButton';

interface IFindTrade {
  setCurrentTrade: React.Dispatch<React.SetStateAction<ITrade>>;
  setTradesList: React.Dispatch<React.SetStateAction<ITradeBasicInfo[]>>;
  setLoadingList: React.Dispatch<React.SetStateAction<boolean>>;
  isOnlySearch: boolean;
  listStatus?: TradeStatusEnum[];
  listPhase?: TradePhaseEnum[];
  showArchivedTrades?: boolean;
  showInCartorio?: boolean;
  searchFilter?: SearchFilterEnum;
}

export function FindTradeComponent(props: IFindTrade) {
  const { tradeSearchService } = useContext(ServiceContext);
  const [searchInput, setSearchInput] = useState<string>("");
  const [searchBy, setSearchBy] = useState<SearchWorkflowCategoryEnum>(SearchWorkflowCategoryEnum.NONE);
  const [qtyTrades, setQtyTrades] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const defaultSearchBy = SearchWorkflowCategoryEnum.OWNER_NAME;

  useEffect(() => {
    if (props.isOnlySearch) {
      setSearchBy(defaultSearchBy)
    }
    else {
      searchTrades();
      setSearchBy(defaultSearchBy)
    }
  }, []);

  function submitSearch(e) {
    if (e.charCode === 13) {
      searchTrades();
    }
  }

  function searchTrades() {
    if (
      props.isOnlySearch &&
      !searchInput &&
      SearchWorkflowCategoryLabel.get(defaultSearchBy) === SearchWorkflowCategoryEnum.NONE
    ) {
      return ShowNotification.Warn("Campo obrigatório!", "Preencha o campo para pesquisar");
    }

    props.setCurrentTrade(null);
    props.setTradesList([]);
    props.setLoadingList(true);
    setLoading(true);

    tradeSearchService
      .getTradesBasicInfo(loadFilterParams())
      .then(resp => {
        if (resp) {
          setQtyTrades(resp.qtyTrades);
          props.setTradesList(resp.tradeBasicInfo);
        }
      })
      .catch(err => ShowNotification.Error("Falhar ao buscar trade", "Não foi possível buscar, tente novamente"))
      .finally(() => {
        setLoading(false);
        props.setLoadingList(false);
      });
  }

  function loadFilterParams(): IQueryTradesBasicInfo {
    return {
      Status: props.listStatus,
      Phase: props.listPhase,
      IsArchived: props.showArchivedTrades ? props.showArchivedTrades : false,
      ShowInCartorio: props.showInCartorio !== undefined ? props.showInCartorio : null,
      FilterBy: props.searchFilter ? props.searchFilter : SearchFilterEnum.All,
      SearchBy: searchBy,
      SearchInput: searchInput
    };
  }

  return (
    <>
      <div className="wrapper">
        <PbrSelect name="searchBy" size="large" defaultValue={SearchWorkflowCategoryLabel.get(defaultSearchBy)} value={searchBy} onChange={e => setSearchBy(e as SearchWorkflowCategoryEnum)} showSearch>
          <Select.Option value="Pesquisar por..." disabled>
            Pesquisar por...
          </Select.Option>
          {Object.keys(SearchWorkflowCategoryEnum).map(value => (
            <Select.Option key={value} value={value}>
              {SearchWorkflowCategoryLabel.get(SearchWorkflowCategoryEnum[value])}
            </Select.Option>
          ))}
        </PbrSelect>

        <Input
          className="find-trade-input"
          value={searchInput}
          name="searchTrade"
          onChange={e => setSearchInput(e.target.value)}
          placeholder="Preencha para pesquisar"
          onKeyPress={submitSearch}
        />
        <button disabled={loading} className="find-trade-button btn" onClick={searchTrades}>
          <FontAwesomeIcon icon={faSearch} />
        </button>
        <div className="left-bold">
          {(!props.isOnlySearch || qtyTrades > 0) && (<>Qtd de trades: <span className="total-trade-count">{qtyTrades} </span></>)}
          {!props.isOnlySearch && (
            <div className="export-all-content">
              <ButtonExport request={loadFilterParams()} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/FindTradeComponent/FindTradeComponent.tsx